import { create } from 'zustand'

interface VersionDrawerState {
  open: boolean
  app_id: string | null
  /** null 表示新建版本（尚未创建草稿） */
  version_id: string | null
  openCreate: (app_id: string) => void
  openVersion: (app_id: string, version_id: string) => void
  /** 草稿创建后把 null 切成真实 id，保持抽屉打开 */
  bindVersionId: (version_id: string) => void
  close: () => void
}

export const useVersionDrawerStore = create<VersionDrawerState>((set) => ({
  open: false,
  app_id: null,
  version_id: null,
  openCreate: (app_id) => set({ open: true, app_id, version_id: null }),
  openVersion: (app_id, version_id) => set({ open: true, app_id, version_id }),
  bindVersionId: (version_id) => set({ version_id }),
  close: () => set({ open: false, app_id: null, version_id: null }),
}))
